import type { LocalProfile } from "./auth-types";

export type SignupIntent = "teacher" | "student";

export type ResolvedSignupIntent = SignupIntent | "ambiguous";

export const SIGNUP_INTENT_KEY = "ccs.auth.signup_intent";

export function parseSignupIntentParam(raw: string | null | undefined): SignupIntent | null {
  if (raw === "teacher" || raw === "student") return raw;
  return null;
}

export function saveSignupIntent(intent: SignupIntent | null | undefined): void {
  if (!intent) return;
  try {
    sessionStorage.setItem(SIGNUP_INTENT_KEY, intent);
  } catch {
    /* storage unavailable */
  }
}

export function loadSignupIntent(): SignupIntent | null {
  try {
    return parseSignupIntentParam(sessionStorage.getItem(SIGNUP_INTENT_KEY));
  } catch {
    return null;
  }
}

export function clearSignupIntent(): void {
  try {
    sessionStorage.removeItem(SIGNUP_INTENT_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Resolve first-login funnel from saved returnTo and signup intent.
 * Precedence: returnTo /join → student, then stored intent, else ambiguous.
 */
export function resolveSignupIntent(
  profile: LocalProfile | null | undefined,
  returnTo?: string | null
): ResolvedSignupIntent {
  if (!profile || profile.role !== "pending") return "ambiguous";

  if (returnTo?.startsWith("/join")) return "student";

  const stored = loadSignupIntent();
  if (stored === "teacher") return "teacher";
  if (stored === "student") return "student";

  return "ambiguous";
}

export function isStudentSignupIntent(
  profile: LocalProfile | null | undefined,
  returnTo?: string | null
): boolean {
  return resolveSignupIntent(profile, returnTo) === "student";
}
